import React, { useContext, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Spinner } from "@chakra-ui/react";

import { logout, userLogout } from "../../APIs";

import { unregister } from "../../Library/worker";
import { AuthContext } from "../../Library/contexts";
import PATHS from "../paths";
import { getItemFromLocalStorage } from "../../Library/helpers";

const Logout = () => {
  const navigate = useNavigate();
  const { setProfile } = useContext(AuthContext);
  const isUser = useRef(getItemFromLocalStorage());

  useEffect(() => {
    let logoutFunction = isUser.current ? userLogout : logout;

    logoutFunction((error) => {
      if (error) console.error(error);
      else {
        if (global.WS && global.WS.wsConnected) {
          global.WS.closeSocket();
          global.WS = null;
        }

        if (global.UWS && global.UWS.wsConnected) {
          global.UWS.closeSocket();
          global.UWS = null;
        }

        unregister();
        setProfile();

        window.localStorage.removeItem("accessCodes");
        window.localStorage.removeItem("des");
        if(!isUser.current) window.localStorage.removeItem("theme");
        window.localStorage.removeItem("relay");
        window.localStorage.removeItem("driverInfo");
        navigate(PATHS.LOGIN, { replace: true });
      }
    });
  }, []);

  return (
    <Spinner />
  );
};

export default Logout;
